module.exports = "/wp-content/themes/conversion/public/dist//svgs/our_approach_selection_two.svg";